<div class="contact-overview__send-message" [innerHTML]="translationService.getTranslation('contact_send')"></div>

<div class="contact-overview__actions mt-3 float-end">
  @if (showBackToOverviewButton) {
    <button
      class="contact-overview__button-back"
      mat-raised-button
      color="primary"
      (click)="backToOverview()"
      [innerHTML]="translationService.getTranslation('button_back_to_overview')">
    </button>
  }
</div>
